import * as React from "react";
import classnames from "classnames";
import { StockIndicator } from "@grandvisionhq/common";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
import { getEyeLabel } from "../../../../../../../../modules/EcommContent/ContactLensesEcommContent/components/CLPrescriptionSelector/components/utils.js";
/* empty css                      */
import { useCLEcommContext } from "../../../../../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
const CLStockIndicator = ({ eyeSideId, className }) => {
  const { isContactLensStockEnabled } = useFeatureToggles();
  const intl = useIntl();
  const { state } = useCLEcommContext();
  const eyeLabel = eyeSideId !== "both" ? getEyeLabel(intl, eyeSideId) : void 0;
  const { stockIndicatorStatus, allowBackOrder } = state.configurator[eyeSideId];
  if (!isContactLensStockEnabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: classnames("cl-stock-indicator", className) }, stockIndicatorStatus && /* @__PURE__ */ React.createElement(React.Fragment, null, eyeLabel && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "cl-stock-indicator__screenreader-text",
      "data-t": "cl-stock-indicator__screenreader-text"
    },
    eyeLabel,
    ":"
  ), /* @__PURE__ */ React.createElement(StockIndicator, { status: stockIndicatorStatus, isBackOrderAllowed: allowBackOrder })));
};
export {
  CLStockIndicator
};
//# sourceMappingURL=CLStockIndicator.js.map
